import { render, staticRenderFns } from "./my_post.vue?vue&type=template&id=3917965c&scoped=true"
import script from "./my_post.vue?vue&type=script&lang=js"
export * from "./my_post.vue?vue&type=script&lang=js"
import style0 from "./my_post.vue?vue&type=style&index=0&id=3917965c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3917965c",
  null
  
)

export default component.exports